import Vue from 'vue'
import Element from 'element-ui'
import scroll from 'vue-seamless-scroll'
import Icon from 'vue-svg-icon/Icon.vue'
import '@/theme/element-#41B883/index.css'
import '@/assets/styl/index'
import '@/mock'
import axios from 'axios'

import App from '@/App'
import { router } from '@/router'
import '@/router/routerControl'
import store from '@/store'
import globalfunc from '@/utils/globalfunc'
Vue.prototype.globalfunc = globalfunc

// import i18n from '@/lang'
import i18n from './i18n/index'

// 为所有 axios 请求添加 lang 请求头
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
axios.interceptors.request.use(
  config => {
    if (i18n && i18n.locale) {
      if (i18n.locale === "en") {
        config.headers["lang"] = "en_US";
      } else if (i18n.locale === "id") {
        config.headers["lang"] = "id_ID";
      } else {
        config.headers["lang"] = "zh_CN";
      }
    }
    config.headers["timeZone"] = timeZone;
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
import localforage from 'localforage'

import VueAMap from 'vue-amap'

const theme = store.getters.theme
Vue.component('icon', Icon)

Vue.use(VueAMap)

VueAMap.initAMapApiLoader({
  // key: 'c0fa67d0b78ea44f02f63192244ffff7',
  key: '41b39784a0c6e74ab628f316bf87a542',
  plugin: [
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.Geocoder'
  ],
  uiVersion: '1.0', // ui库版本，不配置不加载,
  v: '1.4.4'
})

Vue.use(scroll)

// 先同步注册 Element，避免与 metadata 请求回调中的 Vue 挂载产生竞态，
// 导致组件未注册时 el-select 等以未知元素渲染（首屏区号文本溢出）
i18n.locale = 'zh-cn'
Vue.use(Element, {
  size: 'medium',
  i18n: (key, value) => i18n.t(key, value)
})
localforage.getItem('lang').then((lang) => {
  // i18n 的文案按 locale 动态取值，挂载后切换语言依然生效
  i18n.locale = lang || 'zh-cn'
})


Vue.config.productionTip = false

axios
  .get('/host/metadata.do') //http://dev.apureli.srs.lbslm.com/    http://dev.zewone.idongdian.cn
  .then(({ data }) => {
    if (data.status == '200') {
      var host = data.data;
      const appid = host.appid
      store.commit('SET_APPID', appid)
      var json = JSON.parse(host.data);
      if (json.supported_platforms) {
        const platformMap = {
          0: i18n.t('login.phone'),
          1: i18n.t('login.email')
        }
        const platform = json.supported_platforms.map(item => ({
          label: platformMap[item],
          value: item
        }))
        json.supported_platforms = platform
      } else {
        json.supported_platforms = []
      }
      if (json.supported_languages) {
        const LANGUAGE_CONFIG = {
          zh_CN: {
            label: '中文',
            value: 'zh-cn'
          },
          en_US: {
            label: 'English',
            value: 'en'
          },
          id_ID: {
            label: 'Indonesia',
            value: 'id'
          }
        }
        json.supported_languages = (json.supported_languages || [])
          .map(item => LANGUAGE_CONFIG[item])
          .filter(Boolean)
      } else {
        json.supported_languages = []
      }
      //console.log(host.customDisplays, "host customDisplays ~~~~~~~~~~~~~~~~~~~~~~~~~~")
      store.commit('SET_DATA', json)
      store.commit('SET_CUSTOMDISPLAYS', host.customDisplays)
      document.querySelector('head > title').text = json.title.full
      document.querySelector('head > link').href = json.icon
      console.log(`设置appid为:${appid}`)
      updateColor(json.color)
    } else {
      this.$message.error(data.message)
    }
  })
  .catch(err => {
    console.log(err)
    console.log('找不到对应域名的appid')
  })
  .finally(() => {
    // 等外部样式表（Element 主题等）解析完再挂载，避免首屏无样式闪烁；
    // 只等 CSS，不被高德地图脚本/图片等第三方资源阻塞
    window.__APP_STYLES_READY__.then(() => {
      new Vue({
        el: '#app',
        router,
        store,
        i18n,
        components: { App },
        template: '<App/>',
        mounted () {
          // 双 requestAnimationFrame：确保带样式的首帧已绘制，再移除启动遮罩
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const app = document.getElementById('app')
              const loading = document.getElementById('app-boot-loading')
              if (app) app.style.visibility = 'visible'
              if (loading && loading.parentNode) loading.parentNode.removeChild(loading)
            })
          })
        }
      })
    })
  })

export function updateColor (color) {
  function mix (color_1, color_2, weight) {
    function d2h (d) {
      return d.toString(16)
    } // convert a decimal value to hex
    function h2d (h) {
      return parseInt(h, 16)
    } // convert a hex value to decimal

    weight = typeof weight !== 'undefined' ? weight : 50 // set the weight to 50%, if that argument is omitted

    var color = '#'
    for (var i = 0; i <= 5; i += 2) {
      // loop through each of the 3 hex pairs—red, green, and blue
      var v1 = h2d(color_1.substr(i, 2)), // extract the current pairs
        v2 = h2d(color_2.substr(i, 2)),
        // combine the current pairs from each source color, according to the specified weight
        val = d2h(Math.floor(v2 + (v1 - v2) * (weight / 100.0)))

      while (val.length < 2) {
        val = '0' + val
      } // prepend a '0' if val results in a single digit

      color += val // concatenate val to our new color string
    }

    return color // PROFIT!
  }
  const themeCss = `
  .el-table .el-table__header {
    border-bottom: 2px solid {color} !important;
  }

  .site-wrapper .content .content-main .content-top .line {
    background-color: {color} !important;
  }
  .site-wrapper .content .content-main .content-top .register:hover {
    color: {color} !important;
  }
  .site-wrapper .content .content-main .content-top .login:hover {
    color: {color} !important;
  }
  .site-wrapper .content .content-main .phone-code-wrapper {
    color: {color} !important;
  }
  .site-wrapper .content .content-main .factory-selector {
    margin-bottom: 15px;
    display: flex;
    justify-items: end;
  }
  .site-wrapper .content .content-main .factory-selector .el-checkbox__input.is-checked .el-checkbox__inner, .site-wrapper .content .content-main .factory-selector .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: {color} !important;
    border-color: {color} !important;
  }
  .site-wrapper .content .content-main .factory-selector .el-checkbox__input.is-checked + .el-checkbox__label {
    color: {color} !important;
  }

  .el-button--primary {
    color: #ffffff;
    background-color: {color} !important;
    border-color: {color} !important;
  }
  .el-button--primary:hover {
    background: {mix-color} !important;
    border-color: {color} !important;
    color: #ffffff !important;
  }
  .el-button--primary:focus {
    background: {mix-color} !important;
    border-color: {color} !important;
    color: #ffffff !important;
  }

  .el-menu-item.is-active {
      color: {color};
      background-color: {color}!important;
    }

  /*.el-tabs {
    color: {color};
    background-color: {color} !important;
    border-color: {color} !important;
  }*/
  .tags-inner .el-tag-active {
    background-color: {color} !important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: {color};
  }

  .login-wrap .title{
    color: {color} !important;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label{
   color: {color} !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: {color} !important;
    border-color: {color} !important;
  }
  .el-header__title{
   color: {color} !important;
  }



  .el-button--text {
    color: {color}`
  const style = document.createElement('style')
  style.type = 'text/css'
  style.innerHTML = themeCss
    .replace(/{color}/g, color)
    .replace(/{mix-color}/g, mix('ffffff', color.replace('#', ''), 15))
  document.querySelectorAll('head')[0].appendChild(style)
}
